import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconWarning from '../../assets/icons/ic_warning_blue.svg';
import * as sinisterCardsActions from '../../redux/actions/sinister-cards';
import history from '../../utils/history';
import SplitLayout from '../../layout/SplitLayout';
import Select from '../../components/common/select/Select';
import InfoCard from '../../components/content/InfoCard/InfoCard';
import InputPicker from '../../components/common/inputpicker/InputPicker';
import * as http from '../../utils/http';
import { coveragePlans } from '../../data/coveragePlan';

const AdvisorPage = () => {
  const dispatch = useDispatch();
  const currentCoveragePlan = useSelector(
    (state) => state.coverages.currentPlan
  );

  const [listAdvisors, setListAdvisors] = useState([]);
  const [advisorSelected, setAdvisorSelected] = useState(null);
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    async function getListaAsesores() {
      const getListaAsesores = '/asesores';
      const response = await http.get(getListaAsesores, {}, 'SALUD');
      setListAdvisors(response.data.payload.siniestroPTAsesoresBBVA);
    }
    getListaAsesores()
  }, []);


  const validateFormHandler = () => {
    const noEmptyFields = advisorSelected !== null && date !== null && !dateError;
    return !(noEmptyFields);
  };


  const onContinueHandler = () => {
    dispatch(sinisterCardsActions.setAdvisorInfo({ ...advisorSelected, date }));
    history.replace(`/${coveragePlans[currentCoveragePlan].uri}`);
  };

  const leftContent = (
    <div className="titleCont">
      <h1 className="u-mb-24 heading-1">Seguro de Protección de Tarjetas</h1>
      <p>
        Hola, sabemos que ayudarás a los clientes para reportar su siniestro y queremos ayudarte a hacerlo.
      </p>
    </div>
  );

  const onDateChange = (e) => {
    setDate(e.value);

    const currentDate = new Date(e.value);
    const year = currentDate.getFullYear();

    if (e.hasErrorFormat) {
      year < 2010 && year !== 1969
        ? setDateError('*Por favor ingresa una fecha a partir del 2010')
        : setDateError('*Ingrese un fecha válida');
      return;
    }

    setDateError(false);
  };


  const rightContent = (
    <>
      <div className="titleCont">
        <h3 className="u-mb-16">¿Quién realiza la solicitud?</h3>
      </div>

      <div className="firstForm">
        <Select
          items={listAdvisors}
          selected={advisorSelected}
          onClick={setAdvisorSelected}
          label="Selecciona tu nombre*"
        />
        <InputPicker
          label="Fecha de llamada a BBVA"
          maxDate={new Date()}
          minDate={new Date(2014, '00', '01')}
          onChange={onDateChange}
          value={date}
          hasError={dateError}
          untilToday
        />
      </div>

      <div className="section-considerations">
        <p className="subtitle">CONSIDERACIONES</p>
        <div className="content-considerations">
          <p>
            En las siguientes pantallas ingresarás los{' '}
            <strong>datos del cliente siniestrado.</strong>
          </p>
          <p>Antes de comenzar, debes tener a la mano lo siguiente:</p>
          <ul>
            <li>Datos del siniestro</li>
            <li>Documentos completos</li>
            <li>
              Cuentas bancarias del cliente a donde se le reembolsará, de ser aprobado el siniestro.

            </li>
          </ul>
        </div>
      </div>
      <InfoCard
        icon={IconWarning}
        customClasses={'infoCard__no-background'}
        content="Recuerda que al finalizar los flujos llegará una copia con el registro del siniestro a ti y al cliente."
      />
    </>
  );

  return (
    <SplitLayout
      containerClasses="advisorPage"
      leftClasses="advisorPage__left"
      rightClasses="advisorPage__right"
      leftContent={leftContent}
      rightContent={rightContent}
      onNavContinueClick={onContinueHandler}
      navCurrentStep={0}
      navTotalSteps={5}
      isNavActive={false}
      isNavNextDisabled={validateFormHandler()}
      navBtnText={'Continuar'}
    />
  );
};

export default AdvisorPage;